import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import reservationApi from "../../../api/reservationApi";
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Modal, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

import staticVariablesApi from "../../../api/staticVariablesApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import planInfoApi from "../../../api/planInfoApi";
import hotelApi from "../../../api/hotelApi";
import hotelStructureApi from "../../../api/hotelStructureApi";
import UpdateDescriptionPlanForm from "./UpdateDescriptionPlanForm";


const PlanInfoList = () => {
  const theme = useTheme();
  //light or dark green
  const baseBackgroundColor =
    theme.palette.mode === 'dark'
      ? 'rgba(3, 44, 43, 1)'
      : '#fff';
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);

  //data and fetching state
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  //table state
  const [columnFilters, setColumnFilters] = useState(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [refresh, setRefresh] = useState(false);

  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [HotelStructure, SetHotelStructure] = useState({});
  const [HotelPlans, SetHotelPlans] = useState([]);
  const [selectedPlanInfo, setSelectedPlanInfo] = useState([])
  const columns = useMemo(
    () => [
      {
        accessorKey: 'recordNumber',
        header: 'ردیف',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.cityConsistencyTitle',
        id: 'cityConsistencyTitle',
        header: 'شهر',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.hotelName',
        id: 'hotelName',
        header: 'هتل',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.hotelStructureCode',
        id: 'hotelStructureCode',
        header: 'ساختار',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.planCode',
        id: 'planCode',
        header: 'کد پلان',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.firstDescription',
        id: 'firstDescription',
        header: 'توضیحات 1',
        size: 150,
        enableSorting: false,
      },
      {
        accessorKey: 'data.secondDescription',
        id: 'secondDescription',
        header: 'توضیحات 2',
        size: 150,
        enableSorting: false,
      },
      {
        accessorKey: 'data.thirdDescription',
        id: 'thirdDescription',
        header: 'توضیحات 3',
        size: 150,
        enableSorting: false,
      }
    ],
    [],
  );



  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    // getRowId: (row) => row.phoneNumber,

    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    }
    , localization: {

      sortByColumnAsc: '',
      sortByColumnDesc: '',
      sortedByColumnAsc: '',
      sortedByColumnDesc: '',

      // ... and many more - see link below for full list of translation keys
    },

    enableFilters: false,
    enableRowSelection: false
    , muiTableHeadCellProps: {
      //simple styling with the `sx` prop, works just like a style prop in this example
      sx: {
        textAlign: "left",
        backgroundColor: '#86A7FC'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        textAlign: 'left'
      },
    },
    muiTableBodyProps: {
      // sx: (theme) => ({
      //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.1),
      //   },
      //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.2),
      //   },
      //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
      //   {
      //     backgroundColor: lighten(baseBackgroundColor, 0.1),
      //   },
      //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.2),
      //   },
      // }),
    },
    mrtTheme: (theme) => ({
      baseBackgroundColor: baseBackgroundColor,
      draggingBorderColor: theme.palette.secondary.main,
    }),

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor: 'normal',
      },
    }),

    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
      'mrt-row-expand': {
        header: '', //change header text
        muiTableHeadCellProps: {
          align: 'right',
        },
        muiTableBodyCellProps: {
          align: 'right',
        },
      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          AccessControl.checkPermissions(userPermissions, ["PlanInfo:UpdateDescriptionPlan"]) &&

          <Button variant="contained" color="secondary" onClick={() => {
            handleOpenUpdateDescriptionPlanModal(row.original.data)
          }} sx={{ whiteSpace: 'nowrap' }}>
            ویرایش توضیحات
          </Button>
        }
      </Box>
    ),


  });

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
    },
    resolver: yupResolver(schema),
  });

  const getfilteritems = () => {
    const hotelId = watch("hotelId");
    const planCode = watch("planCode");
    const cityConsistency = watch("cityConsistency");
    const hotelStractureId = watch("hotelStractureId");

    const filterItems = [];
    const filterData = {
      "hotelId": hotelId,
      "planCode": parseInt(planCode),
      "cityConsistency": parseInt(cityConsistency),
      "hotelStractureId": hotelStractureId,
      "orderBy": sorting.length > 0 ? sorting[0].id : 'CreateOn',
      "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
      "pageSize": pagination.pageSize,
      "pageNumber": pagination.pageIndex + 1
    }
    return filterData;
  }

  const onSubmit = (data) => {
    const filterData = getfilteritems();
    GetData(filterData);
  };

  useEffect(() => {
    GetCityDropDown();
  }, [])

  useEffect(() => {
    const paginationModel = getfilteritems();
    GetData(paginationModel);
  }, [refresh,
    columnFilters, //re-fetch when column filters change
    globalFilter, //re-fetch when global filter changes
    pagination.pageIndex, //re-fetch when page index changes
    pagination.pageSize, //re-fetch when page size changes
    sorting, //re-fetch when sorting changes
  ]);

  const GetData = (filterData) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    planInfoApi.FilterPlanInfo(filterData)
      .then((res) => {
        setData(res.data.data.items);
        const rowcnt = res.data.data.totalCount;
        setRowCount(rowcnt);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  }

  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
    handleCloseUpdateDescriptionPlanModal();
  }




  const [openUpdateDescriptionPlanModal, setOpenUpdateDescriptionPlanModal] = useState(false);
  const handleOpenUpdateDescriptionPlanModal = (row) => {

    setSelectedPlanInfo(row)
    setOpenUpdateDescriptionPlanModal(true);
  };
  const handleCloseUpdateDescriptionPlanModal = () => {

    setSelectedPlanInfo(null);
    setOpenUpdateDescriptionPlanModal(false);
  };

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const handlePlanChanged = (id) => { }
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    resetField("hotelStructureId")
    resetField("planCode");
    setHotels(null);
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    // resetField("");      
    SetHotelStructure({});
    // setModirRoohaniRoomNumbers(null)
    resetField("planCode");
    // SetPlanInfoStructure(null);

    // if (id) {
    //     const hotelStructure = await fetchHotelStructureByHotelId(id);
    //     SetHotelStructure(hotelStructure);
    //     const hotelPlans = await fetchPlanHotelDropDown(id);
    //     const hotelPlansArr = helper.DictionayToList(hotelPlans);
    //     SetHotelPlans(hotelPlansArr.map((item) => {
    //         return {
    //             label: item.value,
    //             id: item.key
    //         };
    //     }))


    // }

    setHotelStructureIds([]);
    resetField("hotelStructureId")
    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);

      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);
        GetPlanHotelDropDown(arr[0].key);
      }




    }

  }, []);
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
      GetPlanHotelDropDown(id);
    }
  };
  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const GetPlanHotelDropDown = (structureId) => {
    hotelStructureApi.PlanCodeHotelStructureDropDown(structureId).then(res => {
      const arr = helper.DictionayToList(res.data.data);
      SetHotelPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => console.log(err));
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  return (
    <RtlProvider>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Typography component="h1" variant="h5" mb={2}>اطلاعات پایه پلان</Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={1}>
            <RHFAutocomplete
              control={control}
              options={Cities ?? []}
              name="cityConsistency"
              placeholder="شهر"
              onChange={handleCityChanged}
              disabled={Cities === null}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Hotels ?? []}
              name="hotelId"
              placeholder="هتل"
              onChange={handleHotelChanged}
              disabled={Cities === null}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              loading={watch("hotelId") && !hotelStructureIds?.length}
              control={control}
              options={hotelStructureIds ?? []}
              name="hotelStructureId"
              placeholder="ساختار"
              onChange={handleHotelStructureIdChanged}
              disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
              style={{
                border: "none",
                padding: 0,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={HotelPlans ?? []}
              name="planCode"
              placeholder="پلان"
              onChange={handlePlanChanged}
            />

          </Grid>

          <Grid item xs={12} sm={10}>
            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
          </Grid>
        </Grid>

      </form>
      <Box sx={{ display: "flex", flexDirection: 'column' }}>

        <Box sx={{ textAlign: "right", mb: 2, mr: 1.5 }}>تعداد نتایج: {rowCount}</Box>
      </Box>
      <MaterialReactTable table={table} />
      <Modal
        open={openUpdateDescriptionPlanModal}
        onClose={handleCloseUpdateDescriptionPlanModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RtlProvider>
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              ویرایش توضیحات
            </Typography>
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              {selectedPlanInfo && <UpdateDescriptionPlanForm row={selectedPlanInfo} refreshGrid={RefreshGrid} />}
            </Box>
          </Box>
        </RtlProvider>
      </Modal>
    </RtlProvider>
  );
}

export default PlanInfoList;
